export default {
  SettingBaseDataAfterSalesReason: {
    header: {
      code: '原因编码',
      description: '原因描述',
      isUse: '是否已使用',
    },
    newAfterSales: '新增售后原因',
    confirmText: '售后原因',
    msgWarning: '您选中了已使用的数据，不可删除',

    table: {
      code: '原因编码',
      description: '原因描述',
      isUse: '是否已使用',
      descriptionText: '请输入原因描述',
      newAfterSales: '新增售后原因',
      editAfterSales: '编辑售后原因',
      salesChannels: '销售渠道',
      generated: '自动生成',

    }
  }
};
